import { FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Checkbox, Radio, RadioChangeEvent } from 'antd';
import styled, { CSSProperties } from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { ButtonIwText } from '@/_pages/interwill/components/ButtonIwText';
import { getBeneficiaryFullName } from '@/entities/interwills/helpers';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { Icon } from '@/shared/uikit/Icon';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { SelectBeneficiaryListModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../containers/ModalContainerV1';
import { InterwillStyledForm } from '../CreateEntityModal/styled';

export const SelectBeneficiaryListModal: FC<SelectBeneficiaryListModalProps> = ({
  beneficiaries,
  multiple,
  addBeneficiary,
  onSubmit,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectBeneficiaryList' });

  const [checked, setChecked] = useState<DtoId[]>([]);

  const modals = useModalsStore();

  const onSubmitHandler = async () => {
    onSubmit(beneficiaries?.filter((item) => checked.includes(item.id)) ?? []);
    modals.closeModal();
  };

  const commonProps = {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    } as CSSProperties,
    options: beneficiaries?.map((item) => ({
      label: getBeneficiaryFullName(item),
      value: item.id,
    })),

    onChange: (value: DtoId[] | RadioChangeEvent) => {
      if (Array.isArray(value)) {
        setChecked(value);
        return;
      }
      setChecked([value.target.value]);
    },
  };

  return (
    <ModalContainerV1 title={t('title')}>
      <InterwillStyledForm onFinish={onSubmitHandler}>
        <InnerForm>
          <b>{t('selectText')}</b>

          {multiple ? (
            <Checkbox.Group value={checked} {...commonProps} />
          ) : (
            <Radio.Group value={checked[0]} {...commonProps} />
          )}

          <ButtonIwText
            style={{ width: 'fit-content' }}
            icon={<Icon name="plus" size="s20" />}
            onClick={() => {
              modals.closeModal();
              modals.openModal({
                type: 'SelectBeneficiaryTypeModal',
                onSubmit: addBeneficiary,
              });
            }}
          >
            {t('addNewBtn')}
          </ButtonIwText>
        </InnerForm>
        <Buttons>
          <ButtonIw htmlType="submit">{t('btn')}</ButtonIw>
        </Buttons>
      </InterwillStyledForm>
    </ModalContainerV1>
  );
};

const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
`;
